// @ts-nocheck
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useRequest } from "ahooks";
import { toast } from "react-toastify";
import { Loader } from "@mantine/core";
import {
  ApprovalStatus,
  ImageFile,
  Position,
  PositionImage,
  StatusConst,
  UserOrder,
} from "../../interfaces";
import { ArrowIcon, CheckGreenIcon } from "../../assets/svgs";
import DangerModal from "../dialogs/DangerModal";
import useOrderPosition from "../../hooks/useOrderPosition";
import { Storage } from "aws-amplify";
import { checkOrder, updateOrderApi, logout } from "../../api";
import { isEditableCustomerView } from "../../utils";
import { useUser } from "../../contexts";
import useOrder from "../../hooks/useOrder";
import PositionItem from "./PositionItem";
import { MdFilePresent } from "react-icons/md";
import SucessScreen from "./SuccessScreen";

type Props = {
  furtherInfo: string;
  furtherInfoFlowingMotifs: boolean;
  setFurtherInfoFlowingMotifs: (value: boolean) => void;
  furtherInfoQualityCheck: boolean;
  setFurtherInfoQualityCheck: (value: boolean) => void;
  files: ImageFile[];
  confirmationChecked: boolean;
  onConfirmationCheckedChange: (value: boolean) => void;
  setConfirmationChecked: (value: boolean) => void;
};

const SendItemPositions: React.FC<Props> = ({
  furtherInfo,
  furtherInfoFlowingMotifs,
  setFurtherInfoFlowingMotifs,
  furtherInfoQualityCheck,
  setFurtherInfoQualityCheck,
  files,
  confirmationChecked,
  setConfirmationChecked,
  onConfirmationCheckedChange,
}) => {
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [sent, setSent] = useState<boolean>(false);

  const { t } = useTranslation();
  const { positionImageAvailable } = useOrderPosition();
  const [{ order }, dispatchUser] = useUser();
  const { handleOrderUpdate } = useOrder();

  useEffect(() => {
    if (files && files[0]?.key) {
      const fetchPdf = async () => {
        try {
          const url = await Storage.get(files[0].key);
          setPdfUrl(url);
        } catch (error) {
          console.error("Error fetching PDF URL:", error);
          toast.error(t("Failed to fetch PDF"));
        }
      };
      fetchPdf();
    }
  }, [files, t]);

  const {
    data,
    loading: fetching,
    mutate,
  } = useRequest<UserOrder>(() => checkOrder(), {
    ready: order?.id !== "not_found",
  });

  const { run } = useRequest(updateOrderApi, {
    manual: true,
    onSuccess: (value) => {
      if (value) {
        dispatchUser({
          type: "UPDATE",
          order: value,
        });
        setSent(true);
      }
    },
  });

  useEffect(() => {
    if (order) {
      handleOrderUpdate({ id: order.id, lastOpened: order.email });
    }
  }, [order, handleOrderUpdate]);

  const handleRemoveFile = async (index: number, item: Position) => {
    try {
      if (item.positionImage?.length === 0) return;
      order.positions[index] = { ...item, positionImage: [] };
      await handleOrderUpdate({
        id: order?.id,
        positions: order?.positions,
        files: [],
      });
      item.positionImage?.forEach((image) => {
        Storage.remove(image.key);
        Storage.remove(image.thumbnail);
      });
      await Promise.all(order.files.map((file) => Storage.remove(file.key)));
    } catch (error) {
      toast.error(
        (error as Error).message || "We are unable to process this request."
      );
    }
  };

  return (
    <div className="">
      {order.chooseUpload && !positionImageAvailable() && (
        <DangerModal
          handleDelete={() =>
            data?.positions.forEach((item, index) =>
              handleRemoveFile(index, item)
            )
          }
        />
      )}
      {!sent ? (
        <>
          {!fetching && data && data.id !== "not_found" ? (
            <div
              className={`${
                !isEditableCustomerView(data.status) &&
                "opacity-disabled pointer-events-none"
              }`}
            >
              <h3 className="text-xl">{t("positions")}</h3>
              <div className="header-item not-visible">
                <ArrowIcon hide />
              </div>

              <div className="position-items">
                {data?.positions?.map((position, index) => (
                  <PositionItem
                    key={index}
                    item={position}
                    index={index}
                    order={data}
                    mutate={mutate}
                    disabled={!isEditableCustomerView(data.status)}
                    send={true}
                  />
                ))}
              </div>
              <div className="mt-4">
                <h3 className="text-2xl font-bold">{t("furtherInformationInfo")}</h3>
              </div>

              {furtherInfoFlowingMotifs && (
                <div className="mt-8 flex justify-between">
                  <div>
                    <div>
                      <input
                        type="checkbox"
                        id="flowingMotifs"
                        checked={furtherInfoFlowingMotifs}
                        onChange={() =>
                          setFurtherInfoFlowingMotifs(!furtherInfoFlowingMotifs)
                        }
                        disabled
                      />
                      <label htmlFor="flowingMotifs" className="ml-2">
                        {t(
                          "furtherInfoFlowingMotifs"
                        )}
                      </label>
                    </div>
                  </div>
                </div>
              )}

              {/* {furtherInfoQualityCheck && (
                <div className="mt-8 flex justify-between">
                  <div>
                    <div>
                      <input
                        type="checkbox"
                        id="qualityCheck"
                        checked={furtherInfoQualityCheck}
                        onChange={() =>
                          setFurtherInfoQualityCheck(!furtherInfoQualityCheck)
                        }
                        disabled
                      />
                      <label htmlFor="flowingMotifs" className="ml-2">
                        {t("furtherInfoQualityCheck")}
                      </label>
                    </div>
                  </div>
                </div>
              )} */}

              <div className="flex justify-between">
                <div>
                  <div className="my-4">
                    <p className="text-sm font-bold">{t("comment")}</p>
                    <p className="font-thin text-sm">
                      {furtherInfo || t("noFurtherInfo")}
                    </p>
                  </div>
                  <div className="flex flex-col my-2">
                    <p className="text-sm font-bold">
                      {t("file")}
                    </p>

                    <div className="flex my-2 items-center">
                      <MdFilePresent size="1.5rem" />
                      <p className="text-sm">
                        {files.length > 0
                          ? files.map((f) => f?.key).join(", ")
                          : t("noDeliveryNoteUploaded")}
                      </p>
                    </div>
                    <div>
                      {pdfUrl && (
                        <a
                          href={pdfUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-sm hover:underline"
                        >
                         { t("viewfile")}
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex justify-end">
                <div className="flex items-center space-x-2 w-1/4">
                  <input
                    type="checkbox"
                    id="confirm"
                    checked={(data?.status === StatusConst.Waiting || data?.status === StatusConst.Error ? confirmationChecked : true
                    )}
                    onChange={(e) => {
                      const isChecked = e.target.checked;
                      setConfirmationChecked(isChecked);
                      onConfirmationCheckedChange(isChecked);
                    }}
                    className="form-checkbox h-5 w-5 text-blue-600"
                    disabled={!isEditableCustomerView(order.status)}
                  />

                  <label htmlFor="confirm" className="text-gray-700 text-sm">
                    {t(
                      "confirmData"
                    )}
                  </label>
                </div>
              </div>

              {/* <div className="flex justify-end mt-4">
                <button
                  onClick={sendPrintData}
                  className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 disabled:opacity-50"
                  disabled={!confirmationChecked}
                >
                  {t("Submit")}
                </button>
              </div> */}
            </div>
          ) : (
            <div className="row row-center mt-30">
              <Loader />
            </div>
          )}
        </>
      ) : (
        // <div className="sent-printdata text-center mt-10">
        //   <CheckGreenIcon />
        //   <span className="block text-xl font-bold text-green-600">
        //     {t("Upload successful")}
        //   </span>
        //   <p className="mt-4 text-gray-600">{t("Thank you for uploading")}</p>
        //   <p className="p-4">
        //     {t(
        //       "Please note that your upload has been received and is being processed."
        //     )}
        //   </p>
        // </div>
        <SucessScreen />
      )}
    </div>
  );
};

export default SendItemPositions;
